<template>
  <div class="l_invitation_lp">
    <div class="header-wrap">
      <div class="header"></div>
      <hr>
    </div>
    <div class="body-content">
      <h3><span>香の川製麺公式アプリに招待された<br>あなた限定の特典があります♪</span></h3>
      <div class="headline-bg">
      <p class="headline">今、新規会員登録（無料）すると、<br>
        全ミッション達成でスタンプを最大{{this.maxInviteePoint()}}個<br>
        ＆初回クーポンをプレゼント♪</p>
      </div>
      <img class="headline-bg-bottom" :src="require('@/assets/img/invitation-lp/headline_bottom@3x.png')" />
      <p class="label_expire_at">新規会員登録有効期限：{{ this.invitee_expire_at}}</p>
      <div class="install-box">
        <button :class="{hide: cannotInstall}" class="dl-button" v-if="platform === 'ios'" v-on:click="tapInstall">
          <img :src="require('@/assets/img/invitation-lp/dl-btn-ios.svg')" />
        </button>
        <button :class="{hide: cannotInstall}" class="dl-button" v-if="platform === 'android'" v-on:click="tapInstall">
          <img :src="require('@/assets/img/invitation-lp/dl-btn-android.svg')" />
        </button>
        <div :class="{hide: !cannotInstall}" class="disable-dl-content">
          <button class="disable-button">紹介メールの有効期限が切れています</button>
          <p class="text-warning">※お友だちから再度招待メールを送ってもらってください。</p>
        </div>
      </div>
      <div class="install-info-box" v-on:click="goCopyTitle">
        <img :class="{hide: cannotInstall}" class="install-info" :src="require('@/assets/img/install-info.svg')" />
        <p :class="{hide: cannotInstall}" class="install-info-text" onclick="this.goCopyTitle()">ボタンを押してもアプリストアに移動しない場合</p>
      </div>
      <img :src="require('@/assets/img/invitation-lp/lp_2@3x.png')" />
      <div class="present-info-box">
        <div class="present-left">
          <h3 class="present-title-left present-title">あなた</h3>
          <p>新規会員登録（無料）して<br>全ミッションを達成で</p>
          <p><span class="text-large">スタンプ{{this.maxInviteePoint()}}個＋<br>初回クーポンGET！</span></p>
          <img v-for="n of this.maxInviteePoint()" :key="n" class="you-get-stamp" :src="require('@/assets/img/faq/invitation-get-stamp@3x.png')" />
        </div>
        <div class="present-right">
          <h3 class="present-title-right present-title">紹介したお友だち</h3>
          <p>あなたが来店*し<br>スタンプをGETすると</p>
          <p><span class="text-large">紹介スタンプ{{this.inviterPoint}}個<br>GET！</span></p>
          <img v-for="n of this.inviterPoint" :key="n" class="you-get-stamp" :src="require('@/assets/img/faq/invitation-get-stamp@3x.png')" />
        </div>
      </div>
      <p class="text-info">*お友だち紹介スタンプは、紹介したお友だち1人につき1度だけ獲得できます。お友達紹介スタンプ獲得の為には、あなたが紹介リンクを送ったお友だちが紹介リンク発行後{{this.inviteeExpireDays}}日以内にジョイフル公式アプリをインストールし、紹介リンク発行後{{this.inviterExpireDays}}日以内にジョイフル店舗にご来店して初回来店スタンプを獲得する必要がございます。</p>
    </div>
    <div class="you-mission">
    <div class="you-mission-bg">
      <p class="you-mission-title">あなたのミッションを詳しく</p>
      <div class="you-mission-content-wrap">
        <p class="you-mission-content">新規会員登録（無料）で{{this.inviteePoint}}個GET！</p>
        <p class="you-mission-content">プロフィール設定で1個GET！</p>
        <p class="you-mission-content">アプリ設定で1個GET！</p>
        <p class="you-mission-content">初回来店で1個GET！</p>
      </div>
      <div class="you-mission-footer">
        <div class="you-mission-footer-text">
          <p>全部達成で<br>初回クーポンGET!</p>
          <span>(ジョイカフェorポテトフライ無料*)</span>
        </div>
        <img class="you-mission-footer-img" :src="require('@/assets/img/invitation-lp/you-mission-footer-img@3x.png')" />
      </div>
    </div>
    </div>
    <div class="body-content">
      <p class="text-info">*「新規会員登録」:ジョイフル公式アプリダウンロード後、「プロフィール
        設定」画面の「設定するボタン」を押した時点で「新規会員登録」となります。<br>
        *ご利用条件、プロフィール設定、アプリ設定などの詳細はアプリ内でご確認下さい。</p>
      <h3><span>有効期限内に<br>新規会員登録（無料）しよう♪</span></h3>
      <p class="label_expire_at">新規会員登録有効期限：{{ this.invitee_expire_at}}</p>
      <div class="install-box-wrap">
        <img :class="{hide: cannotInstall}" class="install-anno" :src="require('@/assets/img/invitation-lp/install_anno@3x.png')" />
        <div class="install-box">
          <button :class="{hide: cannotInstall}" class="dl-button" v-if="platform === 'ios'" v-on:click="tapInstall">
            <img :src="require('@/assets/img/invitation-lp/dl-btn-ios.svg')" />
          </button>
          <button :class="{hide: cannotInstall}" class="dl-button" v-if="platform === 'android'" v-on:click="tapInstall">
            <img :src="require('@/assets/img/invitation-lp/dl-btn-android.svg')" />
          </button>
          <div :class="{hide: !cannotInstall}" class="disable-dl-content">
            <button class="disable-button">紹介メールの有効期限が切れています</button>
            <p class="text-warning">※お友だちから再度招待メールを送ってもらってください。</p>
          </div>
        </div>
      </div>
      <div :class="{hide: cannotInstall}">
        <p id="copy_title" class="normal-text">ダウンロードボタンを押してもアプリが起動しない場合は、下記のURLをコピーして、ブラウザ（Safari や Chromeなど）からアクセスしてください。</p><br/>
        <p id="dlLink" class="install-url">{{this.dlUrl}}</p>
        <button class="button" v-on:click="tapCopyUrl">
          <span class="c_dl">URLをコピー</span>
        </button>
      </div>
    </div>
    <div class="bottom-content">
      <h3><span>What’s 香の川製麺公式アプリ？</span></h3>
      <p class="text-large">来店で特典と交換できるスタンプや<br>
        ランクごとの豪華特典など、お得がいっぱい♪<br>
        香の川製麺がもっと楽しめます。</p>
    </div>
    <div class="footer">
      <div class="footer-box">
        <div class="footer-link-box">
          <a href="https://www.joyfull.co.jp/" target="_blank">香の川製麺トップページ</a>
          <p>|</p>
          <a href="https://www.joyfull.co.jp/privacy/" target="_blank">個人情報保護方針</a>
        </div>
        <p class="copyright">Copyright © Joyfull Co.,Ltd.All rights reserved.</p>
      </div>
    </div>
    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="this.errorButtonLabel"
        @submit="() => this.errorButtonFunc()"
        @close="() => tapErrorClose()"
      />
    </template>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import ErrorPopup from '../components/Modal/ErrorPopup'
import APIClient, { ErrorCode } from '../api/APIClient'
import app from '../constant/app_config.js'
import copy from 'clipboard-copy'

export default {
  name: 'InvitationLp',
  components: {
    ErrorPopup
  },
  data: function() {
    return {
      // エラー系
      isError: false,
      cannotInstall: false,
      errorMessage: '',
      errorTitle: '',
      errorButtonLabel: '',
      errorButtonFunc: this.tapRetryFetch,

      // データ系
      invitee_expire_at: '',
      platform: '',
      dlUrl: '',
      inviterPoint: 0,
      inviteePoint: 0,
      inviterExpireDays: 0,
      inviteeExpireDays: 0,

      // メッセージ
      title: '香の川製麺アプリ',
      errorTitle1: 'エラー',
      errorTitle2: 'エラー ' + ErrorCode.CODE_ERROR_NETWORK,
      failedCopyErrorTitle: 'コピーに失敗しました',
      successCopyTitle: 'コピーしました',
      alreadyInstalledErrorMessage: '利用できないインストールURLです',
      overInviteeExpireAtErrorMessage: '有効期限切れの招待です',
      failedNetworkErrorMessage: '通信環境の良いところで、再度お試しください。',
      closeButtonLabel: '閉じる',
      retryButtonLabel: 'もう一度試す',

      // DynamicLink
      invitation_uuid: '',
      ofl: app.dynamic_link.ofl,
      apn: app.dynamic_link.apn,
      ibi: app.dynamic_link.ibi,
      isi: app.dynamic_link.isi,
      ius: app.dynamic_link.ius,
      link: app.dynamic_link.link,
      dynamic_url: app.dynamic_link.url
    }
  },
  created() {
    document.title = this.title
    const ua = window.navigator.userAgent
    this.invitee_expire_at = this.$route.query.invitee_expire_at.replace(/-/g, '/')
    this.platform = ua.indexOf('Android') >= 0 ? 'android' : 'ios'
    this.invitation_uuid = this.$route.query.invitation_uuid
    this.errorButtonFunc = this.tapRetryFetch
    this.checkCanInstall()
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    setViewItem: function(data) {
      this.inviterPoint = parseInt(data.inviter_point, 10)
      this.inviteePoint = parseInt(data.invitee_point, 10)
      this.inviterExpireDays = data.inviter_expire_days
      this.inviteeExpireDays = data.invitee_expire_days
      this.invitee_expire_at = data.invitee_expire_at.replace(/-/g, '/')
    },
    async tapInstall() {
      if (this.cannotInstall) {
        return
      }
      this.errorButtonFunc = this.tapInstall
      await this.checkCanInstall()
      if (this.isError || this.cannotInstall) {
        return
      }
      window.location.href = this.dlUrl
    },
    async tapCopyUrl() {
      if (this.cannotInstall) {
        return
      }
      // コピー
      try {
        await copy(this.dlUrl)
        this.showNoRetryAlert(this.successCopyTitle, this.dlUrl)
      } catch (e) {
        this.showNoRetryAlert(this.failedCopyErrorTitle, '')
      }
    },
    async checkCanInstall() {
      this.isError = false
      this.disableScroll()
      this.showLoading()
      try {
        const res = await APIClient.postShowInvitation(
          this.invitation_uuid
        )
        if (res.data.data.code !== ErrorCode.CODE_SUCCESS) {
          this.cannotInstall = true
          let title = 'エラー' + res.data.data.code
          let message = res.data.data.message
          this.showReInstallError(title, message)
          return
        }
        this.setViewItem(res.data.data.invitation_data)
        this.enableScroll()
        if (res.data.data.invitation_data.status !== '0' || res.data.data.invitation_data.is_over_invitee_expire_at) {
          this.cannotInstall = true
          return
        }
        this.cannotInstall = false
        this.dlUrl = this.makeDynamicLink()
      } catch (e) {
        this.showReInstallError(this.errorTitle2, this.failedNetworkErrorMessage)
      } finally {
        this.hideLoading()
      }
    },
    tapRetryFetch() {
      this.checkCanInstall()
    },
    tapErrorClose() {
      this.action_ToggleModal(false)
      this.isError = false
    },
    makeDynamicLink() {
      let link = `${this.link}?invitation_uuid=${this.invitation_uuid}`
      return `${this.dynamic_url}?link=${encodeURIComponent(link)}&apn=${this.apn}&ibi=${this.ibi}&ofl=${encodeURIComponent(this.ofl)}&efr=1&isi=${this.isi}&ius=${this.ius}`
    },
    goCopyTitle() {
      if (this.cannotInstall) {
        return
      }
      let container = document.querySelector('#copy_title')
      container.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    maxInviteePoint() {
      return this.inviteePoint + 3
    },
    showNoRetryAlert(title, message) {
      this.errorButtonFunc = this.tapErrorClose
      this.showError(title, message, this.closeButtonLabel)
    },
    showReInstallError(title, message) {
      this.errorButtonFunc = this.checkCanInstall
      this.showError(title, message, this.retryButtonLabel)
    },
    showError(title, message, label) {
      this.action_ToggleModal(true)
      this.errorTitle = title
      this.errorMessage = message
      this.errorButtonLabel = label
      this.isError = true
    },
    disableScroll() {
      this.action_ToggleModal(true)
    },
    enableScroll() {
      this.action_ToggleModal(false)
    },
    showLoading() {
      this.actionToggleLoading(true)
    },
    hideLoading() {
      this.actionToggleLoading(false)
    }
  }
}
</script>

<style scoped lang="scss">
/* all */
.l_invitation_lp {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}
/* header */
.l_invitation_lp .header-wrap {
  height: 100%;
  width: 100%;
  background-color: #66160E;
}
.l_invitation_lp .header-wrap hr {
  border: none;
  border-bottom: 2px solid #efb90f;
}
.l_invitation_lp .header {
  padding-left: 10px;
  height: 40px;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
.l_invitation_lp .header img {
  width: 78px;
  vertical-align: middle;
}

/* body */
.l_invitation_lp .body-content {
  padding-left: 3%;
  padding-right: 3%;
}
.l_invitation_lp h3 {
  padding-top: 20px;
  color: #602209;
  text-align: center;
  line-height: 1.68;
}
.l_invitation_lp h3 span {
  border-bottom: dotted 2.5px;
  font-size: 5.7vw;
}
.l_invitation_lp .body-content img {
  padding-top: 6%;
  width: 100%;
}

.l_invitation_lp .body-content .label_expire_at {
  margin-top: 7px;
  padding: 7px 0;
  margin-bottom: 12px;
  font-size: 4vw;
  font-weight: 600;
  color: #ffffff;
  background-color: #E03535;
}

.l_invitation_lp .body-content .install-box {
  margin-bottom: 12px;
  padding-bottom: 2%;
  background-color: #EEEEEE;
  display: flex;
  justify-content: space-around;
}

.l_invitation_lp .body-content .install-info-box {
  display: flex;
  justify-content: center;
}
.l_invitation_lp .body-content .install-info-box .install-info {
  width: 4%;
  padding: 0;
  margin-right: 2px;
}
.l_invitation_lp .body-content .install-info-box .install-info-text {
  font-size: 3vw;
  font-weight: 300;
  border-bottom: #000000 solid 0.5px;
}

.l_invitation_lp .body-content a {
  color: #000000;
  font-size: 14px;
}

.l_invitation_lp .body-content .present-info-box {
  margin-top: 14px;
  display: flex;
  justify-content: space-around;
}

.l_invitation_lp .body-content .present-info-box p {
  margin-top: 12px;
  font-size: 3vw;
  font-weight: 600;
  color: #66160E;
}

.l_invitation_lp .body-content .present-info-box .text-large {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-size: 5vw;
  font-weight: 800;
}

.l_invitation_lp .body-content .present-left {
  width: 100%;
}
.l_invitation_lp .body-content .present-right {
  width: 100%;
}
.l_invitation_lp .body-content .present-title-left {
  margin-right: 5px;
}

.l_invitation_lp .body-content .present-title-right {
  margin-left: 5px;
}

.l_invitation_lp .body-content .present-title {
  width: 100%;
  padding: 2px;
  background-color: #602209;
  border-radius: 30px;
  text-align: center;
  font-size: 4vw;
  color: #ffffff;
}

.l_invitation_lp .body-content .text-info {
  margin-top: 10px;
  font-size: 2.5vw;
  text-align: left;
  color: #666666;
}

.l_invitation_lp .body-content .present-info-box .you-get-stamp {
  padding-top: 0 !important;
  width: 20%;
}

.l_invitation_lp .body-content .present-info-box .friend-get-stamp {
  padding-top: 0 !important;
  width: 38% !important;
}

.l_invitation_lp .you-mission {
  margin-top: 12px;
  padding-left: 3%;
  padding-right: 3%;
}

.l_invitation_lp .you-mission-bg {
  position: relative;
  border-radius: 5px;
  border: 1px solid #66160E;
}

.l_invitation_lp .you-mission-bg span {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-weight: 800;
  font-size: 3vw;
  padding-top: 0;
}

.l_invitation_lp .you-mission-title {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-size: 4vw;
  font-weight: 800;
  background-color: #66160E;
  border-radius: 5px 5px 0 0;
  color: #ffffff;
  padding-top: 10px;
  padding-bottom: 10px;
}

.l_invitation_lp .you-mission-footer {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-size: 5vw;
  font-weight: 800;
  text-align: left;
  line-height: 1.2;
  background-color: var(--background-color);
  color: #66160E;
  padding-top: 2%;
  padding-left: 8%;
  padding-bottom: 2%;
  border-radius: 0 0 5px 5px;
  border: none;
  display: flex;
  justify-content: space-between;
}

.l_invitation_lp .you-mission-footer-text {
}

.l_invitation_lp .you-mission-footer-img {
  height: 100%;
  width: 40%;
  text-align: right;
  margin-right: -5px;
  margin-bottom: -10px;
}

.l_invitation_lp .you-mission-content::before {
  content: '';
  width: 1em;
  height: 1em;
  background: url('../assets/img/invitation-lp/mission-logo.svg') no-repeat;
  background-size: cover;
  position: absolute;
  top: 0.5em;
  left: 0;
}

.l_invitation_lp .you-mission-content {
  font-family: 'HiraKakuPro-W6', sans-serif;
  width: 100%;
  padding-left: 6%;
  font-size: 4vw;
  font-weight: 600;
  text-align: left;
  color: #66160E;
  line-height: 2.0;
  position: relative;
}

.l_invitation_lp .you-mission-content-wrap {
  padding-top: 14px;
  padding-bottom: 14px;
  margin-left: 18%;
}

.l_invitation_lp .body-content .install-box-wrap {
  background-color: #EEEEEE;
}

.l_invitation_lp .body-content .install-box-wrap .install-anno {
  padding-left: 3%;
  padding-right: 3%;
}

.l_invitation_lp .body-content .normal-text {
  font-size: 2.9vw;
  text-align: left;
  color: #000000;
}

.l_invitation_lp .body-content .button {
  width: 100%;
  padding: 4% 0;
  margin: 14px 0 14px 0;
  background-color: #602209;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  border: none;
  outline: none;
  appearance: none;
}

.l_invitation_lp .body-content .disable-dl-content {
  width: 100%;
  margin: 4%;
}

.l_invitation_lp .body-content .disable-button {
  width: 100%;
  padding: 4% 0;
  font-size: 4vw;
  background-color: #999999;
  border-radius: 6px;
  color: white;
  border: none;
  outline: none;
  appearance: none;
}

.l_invitation_lp .body-content .button .c_dl {
  font-size: 4vw;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  color: #ffffff;
  padding-left: 6%;
  position: relative;
  display: inline;
}

.l_invitation_lp .body-content .button .c_dl::before {
  content: '';
  width: 1em;
  height: 1em;
  background: url('../assets/img/upload.svg') no-repeat;
  background-size: cover;
  position: absolute;
  left: 0;
}

.l_invitation_lp .bottom-content {
  background-color: var(--background-color);
  width: 100%;
  padding-left: 12px;
  padding-right: 12px;
}

.l_invitation_lp .bottom-content p {
  margin-top: 20px;
  font-size: 3.5vw;
  font-weight: 600;
  padding-left: 8px;
  padding-right: 8px;
}

.l_invitation_lp .bottom-content img {
  width: 100%;
}
.l_invitation_lp .footer {
  height: 100px;
  background-color: #66160E;
}

.l_invitation_lp .footer .footer-box {
  padding-top: 30px;
  margin: 0 auto;
}

.l_invitation_lp .footer .footer-link-box {
  display: flex;
  justify-content: center;
}

.l_invitation_lp .footer .footer-link-box p {
  padding-left: 4px;
  padding-right: 4px;
  color: #ffffff;
}

.l_invitation_lp .footer .footer-link-box a {
  font-size: 13px;
  color: #ffffff;
  text-decoration: none;
}

.l_invitation_lp .footer .copyright {
  font-size: 10px;
  color: #ffffff;
}

.l_invitation_lp .install-url {
  font-size: 2.9vw;
  text-align: left;
  word-break: break-all;
}

.l_invitation_lp .dl-button {
  width: 48%;
  cursor: pointer;
  border: none;
  outline: none;
  appearance: none;
  background-color: transparent;
}

.l_invitation_lp .headline {
  padding-top: 3%;
  padding-bottom: 8%;
  font-family: 'HiraKakuPro-W6', sans-serif;
  font-weight: 600;
  font-size: 4.5vw;
  color: #66160E;
}

.l_invitation_lp .headline-bg {
  position: relative;
  z-index: 2;
  margin-top: 18px;
  background-image: url('../assets/img/invitation-lp/lp_headline_bg@3x.png');
  background-size: 100% 100%;
}

.l_invitation_lp .headline-bg-bottom {
  position: relative;
  z-index: 1;
  margin-top: -30px;
  padding-left: 10%;
  padding-right: 10%;
}

.l_invitation_lp .hide {
  display: none;
}

.l_invitation_lp .text-warning {
  font-weight: 600;
  font-size: 3vw;
  color: #E03535;
  padding-top: 2%;
}
</style>
